export const texts = {
  dashboard: {
    de: 'Dashboard',
    en: 'Dashboard'
  },
  positions: {
    de: 'Stellen',
    en: 'Positions'
  },
  settings: {
    de: 'Einstellungen',
    en: 'Settings'
  },
  logout: {
    de: 'Logout',
    en: 'Logout'
  }
};
